import { CARD_STATUS, TRANSACTION_CARD_TYPES } from '../payment_enums';
import { portal } from '../../../Configs/general';

export const getTotalAmount = payments => {
  const totalAmount = payments.reduce(
    (value, payment) => Number(value) + Number(payment.detail.couponValue),
    0
  );
  return totalAmount;
};

export const updateItem = (
  oldPayload,
  targetKey,
  filterKey,
  filterValue,
  targetStatus,
  newBody
) => {
  const filteredValues = oldPayload[targetKey].filter(
    item => String(item.detail[filterKey]) !== String(filterValue)
  );
  newBody.status = CARD_STATUS[targetStatus.toUpperCase()];
  return {
    ...oldPayload,
    loading: filteredValues,
    [targetStatus]: [...oldPayload[targetStatus], newBody]
  };
};

export const updatePayment = (oldPayments, transactionType, newPayload) => {
  switch (transactionType) {
    case TRANSACTION_CARD_TYPES.COUPON:
      return [
        ...oldPayments,
        {
          type: transactionType,
          status: CARD_STATUS.TOPAY,
          detail: {
            ...newPayload,
            couponId: newPayload.id,
            couponValue: newPayload.value
          }
        }
      ];

    case TRANSACTION_CARD_TYPES.CONTRACT:
      return [
        ...oldPayments,
        {
          type: transactionType,
          status: CARD_STATUS.TOPAY,
          detail: newPayload
        }
      ];

    default:
      return oldPayments;
  }
};

export const buildContractCardData = data => {
  const contractData = data.data[0];
  return {
    requestData: contractData,
    cardBody: {
      type: TRANSACTION_CARD_TYPES.CONTRACT,
      detail: {
        ...contractData,
        loading: false
      }
    }
  };
};

export const getCardStatus = cardData => {
  if (cardData.isPaid) {
    return CARD_STATUS.PAID;
  }

  if (cardData.isPending) {
    return CARD_STATUS.PENDING;
  }

  return CARD_STATUS.TOPAY;
};

export const isPaymentOptionDisabled = option => {
  if (!option) {
    return false;
  }

  if (Boolean(option.disabled)) {
    return true;
  }

  return (
    Array.isArray(option.disabledCompany) &&
    option.disabledCompany.includes(portal)
  );
};

export const getFirstEnabledPaymentOption = (options = []) => {
  return options.find(option => !isPaymentOptionDisabled(option));
};

export const normalizePaymentType = (options = [], currentType) => {
  const selectedOption = options.find(option => option.value === currentType);

  if (selectedOption && !isPaymentOptionDisabled(selectedOption)) {
    return currentType;
  }

  const firstEnabledOption = getFirstEnabledPaymentOption(options);
  return firstEnabledOption ? firstEnabledOption.value : '';
};
